import Phaser from 'phaser'
import GameUtil from '../utils/game-util'

export default class Counter {
  /** @type Phaser.GameObjects.Sprite */
  Counter = null

  /**
   * @type {{
   * context: Phaser.Scene,
   * }}
   **/
  sceneContext = {}

  /**
   * @param {Phaser.Scene} context
   */
  constructor(context) {
    this.sceneContext = context
  }

  preload() {}

  create() {
    this.Counter = this.sceneContext.add
      .text(0, 0, '0', {
        fontFamily: 'BwModelica-Bold',
        color: '#FFFFFF',
        fontSize: this.sceneContext.isMobile ? '17px' : '35px',
        align: 'center',
      })
      .setOrigin(0.5)
      .setDepth(2)
      .setAlpha(0)
    // .setVisible(false)
  }

  hideCount() {
    this.sceneContext.tweens.add(
      {
        targets: this.Counter,
        alpha: 0,
        duration: 500,
        ease: 'Power2',
      },
      this.sceneContext
    )
  }

  showCount({ count, element }) {
    this.Counter.setText(count || 0)
    this.Counter.x = element.x
    this.Counter.y = element.y - element._displayOriginY

    this.sceneContext.tweens.add(
      {
        targets: this.Counter,
        alpha: 1,
        duration: 500,
        ease: 'Power2',
        onComplete: () => {
          this.sceneContext.time.addEvent({
            delay: 500,
            callback: () => this.hideCount(),
          })
        },
      },
      this.sceneContext
    )
  }
}
